import React, { useEffect } from "react";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import BottomButtons from "components/buttons/bottomButtons";
import HeadingComponent from "components/headingComponent";
import ErrorMessages from "helper/errorMessages";
import ButtonLabels from "helper/constant/buttonLabels";
import CommonHeadings from "helper/constant/headings";
import { dbFirestore } from "helper/config/firebase";
import TableName from "helper/tableName/tableName";
import RoutingPaths from "helper/routingPath";
import ToastMessages from "helper/toastMessages";
import {
  addDoc,
  and,
  collection,
  doc,
  getDocs,
  or,
  query,
  Timestamp,
  updateDoc,
  where,
} from "firebase/firestore";
import moment from "moment";
import AsyncSelect from "react-select/async";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Dateformat from "helper/constant/timeFormat";
import "./index.css";

function AddSalaryExpenses() {
  const [isSubmitted, setIsSubmitted] = useState(false); // when we submit the form, it will check the error
  const [salaryDate, setSalaryDate] = useState(null); // only use in the primereact calendar when we select the salary date
  const [salaryMonthDate, setSalaryMonthDate] = useState(null);
  const [expenseHeading, setExpenseHeading] = useState(
    CommonHeadings.expenseAddHeading
  );
  const [buttonLabel, setButtonLabel] = useState(ButtonLabels.saveLabel);
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [expensesID, setExpensesID] = useState();
  const navigate = useNavigate();
  const location = useLocation();
  
  const [expenses, setExpenses] = useState({
    // set input values
    teacher_id: null,
    no_of_days: moment(new Date()).daysInMonth(),
    salary: null,
    salary_num: null,
    salary_date: null,
    salary_month: null,
    salary_month_num: null,
    salary_date_num: null,
    description: "",
  });

  const [errors, setErrors] = useState({
    teacher_id: "",
    no_of_days: "",
    salary: "",
    salary_date: "",
    salary_month: "",
    description: "",
  });

  // MARK: use effect function
  useEffect(() => {
    fetchTeachersApi();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // MARK: Validation error
  const validateForm = (data) => {
    const errors = {};

    if (!data.teacher_id) {
      errors.teacher_id = ErrorMessages.teacherID;
    }
    if (!data.no_of_days) {
      errors.no_of_days = ErrorMessages.noOfDays;
    } else if (!/^\d*$/.test(data.no_of_days)) {
      errors.no_of_days = ErrorMessages.noOfDaysFormat;
    }
    if (!data.salary) {
      errors.salary = ErrorMessages.salary;
    } else if (!/^\d*$/.test(data.salary)) {
      errors.salary = ErrorMessages.salaryNumber;
    }
    if (!data.salary_date) {
      errors.salary_date = ErrorMessages.date;
    }
    if (!data.salary_month) {
      errors.salary_month = ErrorMessages.salaryMonth;
    }
    if (!data.description) {
      errors.description = ErrorMessages.description;
    }

    return errors;
  };

  const inputChange = (e) => {
    var { name, value } = e.target;

    setExpenses({
      ...expenses,
      [name]: value,
    });
  };

  const teacherSelect = (e) => {
    const name = "teacher_id";

    setExpenses({
      ...expenses,
      [name]: e,
    });

    const newErrors = validateForm(expenses);
    setErrors(newErrors);
  };

  // MARK: fetch teacher API
  async function fetchTeachersApi(e) {
    let q = query(collection(dbFirestore, TableName.teachers));

    const querySnapshot = await getDocs(q);
    const array = querySnapshot.docs.map((docs) => ({
      ...docs.data(),
      firebase_id: docs.id,
    }));

    //  edit functionality
    if (location.state) {
      setEditExpensessUI(array);
    }
  }

  // MARK: edit data function
  function setEditExpensessUI(arrayTeacher) {

    const salaryDate = moment(
      location.state.salary_date,
      Dateformat.YYYYMMDD
    ).toDate();
    setSalaryDate(salaryDate);

    const monthDate = moment(
      location.state.salary_month,
      Dateformat.MMYYYY
    ).toDate();
    setSalaryMonthDate(monthDate);

    var teacherObject = arrayTeacher.find(function (teacher) {
      return teacher.firebase_id === location.state.teacher_id;
    });

    setExpenses((prevState) => ({
      ...prevState,
      teacher_id: teacherObject,
      no_of_days: location.state.no_of_days,
      salary: location.state.salary,
      salary_date: salaryDate,
      salary_month: monthDate,
      description: location.state.description,
    }));
    setExpenseHeading(CommonHeadings.expenseEditHeading);
    setButtonLabel(ButtonLabels.updateLabel);
    setExpensesID(location.state.id);
  }

  // MARK: payload function
  function payload() {
    const createdAt = Timestamp.fromDate(new Date()).toMillis();

    const object = {
      ...expenses,
      created_at: createdAt,
      updated_at: null,
    };

    object.salary_num = Number(expenses.salary);

   object.salary_date = moment(expenses.salary_date).format(Dateformat.YYYYMMDD)
   object.salary_date_num= Timestamp.fromDate(
      new Date(object.salary_date)
    ).toMillis();

    object.salary_month = moment(expenses.salary_month).format(Dateformat.MMYYYY)
    const salaryMonthExpenseDate = Timestamp.fromDate(expenses.salary_month).toMillis();
    object.salary_month_num = salaryMonthExpenseDate;
    object.description = expenses.description.toLowerCase();

    return object;
  }

  // MARK: reset values function
  function ResetValues() {
    setExpenses({
      teacher_id: "",
      no_of_days: "",
      salary: null,
      salary_num: null,
      salary_date: null,
      salary_month: null,
      salary_month_num: null,
      salary_date_num: null,
      description: "",
    });
  }

  // MARK:  API
  // write API
  async function writeExpensesApi(edit) {
    const writePayload = payload();
    writePayload.teacher_id = expenses.teacher_id?.firebase_id;

    try {
      await addDoc(collection(dbFirestore, TableName.salaryExpenses), {
        ...writePayload,
      });

      if (edit) {
        toast.success(ToastMessages.expenseAdd);
        setTimeout(() => {
          setLoading2(false);
          // when user press on save + next
          navigate(RoutingPaths.addSalaryexpenses);
          ResetValues();
        }, 600);
      } else {
        toast.success(ToastMessages.expenseAdd);
        setTimeout(() => {
          setLoading1(false);
          navigate(RoutingPaths.salaryExpensesList);
        }, 600);
      }
    } catch (error) {
      setLoading1(false); // hide
      setLoading2(false);
      const errorMessage = error.message;
      toast.error(errorMessage);
    }
  }

  // update API
  async function updateExpensesApi() {
    const updatedPayload = payload();
    updatedPayload.created_at = location.state.created_at;
    updatedPayload.updated_at = Timestamp.fromDate(new Date()).toMillis();
    updatedPayload.teacher_id = expenses.teacher_id?.firebase_id;


    try {
      await updateDoc(doc(dbFirestore, TableName.salaryExpenses, expensesID), {
        ...updatedPayload,
      });
      toast.success(ToastMessages.expenseUpdated);
      setTimeout(() => {
        setLoading1(false);
        navigate(RoutingPaths.salaryExpensesList);
      }, 600);
    } catch (error) {
      setLoading1(false);

      const errorMessage = error.message;
      toast.error(errorMessage);
    }
  }

  // this function is working when we submit the form by clicking on save button
  const tapOnSave = () => {
    const newErrors = validateForm(expenses);
    setErrors(newErrors);
    setIsSubmitted(true);
    if (Object.keys(newErrors).length === 0) {
      setLoading1(true);
      if (location.state) {
        updateExpensesApi();
      } else {
        writeExpensesApi();
      }
    }
  };

  // MARK: tap on button
  // this function is working when we submit the form by clicking on save andnext button
  const tapOnSaveNext = () => {
    const newErrors = validateForm(expenses);
    setErrors(newErrors);
    setIsSubmitted(true);
    if (Object.keys(newErrors).length === 0) {
      setLoading2(true);
      writeExpensesApi(true);
    }
  };

  // MARK: teacher list fetch from the firebase
  const teacherList = async (searchText) => {
    const searchName = searchText.toLowerCase()

    let q = query(
      collection(dbFirestore, TableName.teachers),and(
                    where('status', '==', 'active'),   
      or(
        // query as-is:
        and(
          where("name", ">=", searchName),
          where("name", "<=", searchName + "\uf8ff")
        ),
        and(
          where(
            "name",
            ">=",
            searchName.charAt(0).toUpperCase() + searchName.slice(1)
          ),
          where(
            "name",
            "<=",
            searchName.charAt(0).toUpperCase() + searchName.slice(1) + "\uf8ff"
          )
        )
      )
    ));
    
    const querySnapshot = await getDocs(q);

    const s = querySnapshot.docs.map((docs) => ({
      ...docs.data(),
      firebase_id: docs.id,
    }));

    return s;
  };

  // MARK: teacher name which show in the dropdown
  function teacherName(e) {
    return e["name"] + " - " + e["contact_no"];
  }

  return (
    <div className="modules__main__div">
      <div className="col-12">
        <div className="card modules__card">
          <HeadingComponent classname="mb-4" headingName={expenseHeading} />
          {/* p-fluid is the primereact class */}
          <div className="p-fluid">
            <div className="row modules__row">
              <div className="col-12 col-md-6">
                <label htmlFor="teacher_id" className="input__valid">
                 Select Teacher 
                </label>
                <AsyncSelect
                  maxMenuHeight={170}
                  isClearable
                  cacheOptions
                  loadOptions={teacherList}
                  value={expenses.teacher_id}
                  defaultOptions
                  getOptionLabel={(e) => teacherName(e)}
                  getOptionValue={(e) => e["id"]}
                  onChange={teacherSelect}
                />
                {isSubmitted && (
                  <small id="teacher_id" className="p-error">
                    {errors.teacher_id}{" "}
                  </small>
                )}
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="no_of_days" className="input__valid">
                  Number of Working Days
                </label>
                <InputText
                  name="no_of_days"
                  value={expenses.no_of_days}
                  onChange={inputChange}
                  id="no_of_days"
                  type="tel"
                  placeholder="Enter no. of working days"
                />
                {isSubmitted && (
                  <small id="no_of_days" className="p-error">
                    {errors.no_of_days}{" "}
                  </small>
                )}
              </div>
              <div className="col-12 col-md-6">
                <label htmlFor="salary" className="input__valid">
                  Salary
                </label>
                <InputText
                  name="salary"
                  value={expenses.salary}
                  onChange={inputChange}
                  id="salary"
                  type="tel"
                  placeholder="Enter your salary"
                />
                {isSubmitted && (
                  <small id="salary" className="p-error">
                    {errors.salary}{" "}
                  </small>
                )}
              </div>
              <div className="col-12 col-md-6">
                <label htmlFor="salary_month" className="input__valid">
                  Salary Month
                </label>
                <Calendar
                  name="salary_month"
                  value={salaryMonthDate}
                  onChange={inputChange}
                  view="month"
                  dateFormat="mm/yy"
                  showIcon
                  showButtonBar
                  placeholder="mm/yyyy"
                />
                {isSubmitted && (
                  <small id="salary_month" className="p-error">
                    {errors.salary_month}{" "}
                  </small>
                )}
              </div>
              <div className="col-12 col-md-6">
                <label htmlFor="salary_date" className="input__valid">
                  Salary Date
                </label>
                <Calendar
                  name="salary_date"
                  value={salaryDate}
                  onChange={inputChange}
                  showIcon
                  showButtonBar
                  placeholder="dd-MM-yy"
                  dateFormat="dd-MM-yy"
                />
                {isSubmitted && (
                  <small id="salary_date" className="p-error">
                    {errors.salary_date}{" "}
                  </small>
                )}
              </div>
              <div className="col-12 col-md-6">
                <label htmlFor="description" className="input__valid">
                  Description
                </label>
                <InputTextarea
                  name="description"
                  value={expenses.description}
                  onChange={inputChange}
                  id="description"
                  placeholder="Enter description"
                  rows={3}
                  cols={30}
                />
                {isSubmitted && (
                  <small id="description" className="p-error">
                    {errors.description}{" "}
                  </small>
                )}
              </div>
            </div>
          </div>

          <BottomButtons
            label={buttonLabel}
            save={tapOnSave}
            loading1={loading1}
            saveNext={tapOnSaveNext}
            loading2={loading2}
          />
          <ToastContainer />
        </div>
      </div>
    </div>
  );
}

export default AddSalaryExpenses;
